import { Capacitor } from "@capacitor/core";
import { SafeArea } from "capacitor-plugin-safe-area";
import { useEffect, useMemo, useState } from "react";

export const getDevice = () => Capacitor.getPlatform();

export const isMobile = () =>
  getDevice() === "ios" || getDevice() === "android";

export const useSafeArea = () => {
  const [insets, setInsets] = useState();
  useEffect(() => {
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      setInsets(insets);
    });
  }, []);
  return useMemo(() => insets, [insets]);
};
